var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.name),expression:"name"},{name:"show",rawName:"v-show",value:(_vm.id),expression:"id"}],staticClass:"flag",style:({backgroundImage: _vm.flag})})
}
var staticRenderFns = []

export { render, staticRenderFns }